import React, { useEffect, useState } from 'react';
import { navigation } from '../../data/portfolio';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (!isMenuOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsMenuOpen(false);
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [isMenuOpen]);

  return (
    <header className="site-header">
      <div className="shell header-inner">
        <a className="brand" href="#home" onClick={() => setIsMenuOpen(false)} aria-label="Muhammed Nihas, back to top">
          <span className="brand-mark">MN<span>.</span></span>
          <span className="brand-label">AI ENGINEER</span>
        </a>
        <button className="menu-toggle" type="button" aria-controls="primary-navigation" aria-expanded={isMenuOpen} onClick={() => setIsMenuOpen((open) => !open)}>
          {isMenuOpen ? 'Close' : 'Menu'} <span aria-hidden="true">{isMenuOpen ? '×' : '+'}</span>
        </button>
        <nav id="primary-navigation" className={isMenuOpen ? 'primary-nav is-open' : 'primary-nav'} aria-label="Main navigation">
          {navigation.map((item) => <a key={item.href} href={item.href} onClick={() => setIsMenuOpen(false)}>{item.label}</a>)}
        </nav>
        <a className="header-contact" href="mailto:muhammednihas2218@gmail.com">Let's talk <span aria-hidden="true">↗</span></a>
      </div>
    </header>
  );
};

export default Header;
